<script setup lang="ts">
import { onMounted } from 'vue';

onMounted(() => {
  // Mark that we're on a store page, so when user goes back, filters can be restored
  if (typeof window !== 'undefined') {
    try {
      sessionStorage.setItem('casino_navigation_from_game', 'true');
    } catch (e) {
      // Ignore storage errors
    }
  }
});
</script>

<template>
  <div :class="$style.centerPage">
    <VipStoreV2 />
  </div>

  <h1 class="text-white/60 text-center mb-8 px-4 leading-tight">
    Loja VIP Apostatudo: benefícios exclusivos
  </h1>
</template>

<style module lang="postcss">
.centerPage {
  @apply w-full min-h-[600px] flex justify-center relative -mt-1 lg:-mt-4;
}
</style>
